// Re-export configuration
export { AppConfig, isDevelopment, isProduction } from './config';

// Re-export strings for localization
export * from './strings';

// Re-export marketplace constants and strings
export * from './marketplaceConstants';
export { MARKETPLACE_COLORS } from './marketplaceColors';

// Re-export unified color system
export {
  PRIMITIVE_COLORS,
  SEMANTIC_COLORS,
  COMPONENT_COLORS,
  MOBILE_LIGHT_COLORS,
  RESIDENT_COLORS,
} from './residentColors';
export type { PrimitiveColor, SemanticColor, ComponentColor } from './residentColors';

// Application constants
export const APP_CONSTANTS = {
  // Navigation
  TAB_BAR_HEIGHT: 50,
  NAVIGATION_TITLE_FONT_SIZE: 15,
  NAVIGATION_LARGE_TITLE_FONT_SIZE: 22,
  
  // UI
  BUTTON_CORNER_RADIUS: 8,
  TEXT_FIELD_HEIGHT: 48,
  INPUT_FONT_SIZE: 16,
  LABEL_FONT_SIZE: 14,
  
  // Timeouts
  DEFAULT_ANIMATION_DURATION: 300,
  DEBOUNCE_DELAY: 500,
  
  // Validation
  MAX_INPUT_LENGTH: 240,
  
  // Styling
  ENABLED_ALPHA: 1.0,
  DISABLED_ALPHA: 0.5,
} as const;

// The fixed-light COLORS palette that used to live here was retired in #252 and
// #254–#257. Every consumer now reads from the theme, so it was deleted rather
// than left as a tempting shortcut back onto a hardcoded light palette.

export const MAX_ATTACHMENTS = 7;

// Maintenance constants
export const MAINTENANCE_CONSTANTS = {
  MINIMUM_TIME_SLOTS: 3,
  SEVERITY_FALLBACK_LABELS: [
    "It doesn't affect me at the moment",
    "It creates discomfort",
    "No reasonable workaround available",
    "Can't use the apartment",
  ],
} as const;

// Re-export utilities for convenience
export { formatAsPhoneNumber, cleanPhoneNumber, isValidPhoneNumber } from '../../utils/residents/utils';

// Re-export invitation status constants
export * from './invitationStatus';

// Re-export admin constants
export * from '../admin'; 